import { oliveBadgeTokens } from '@ds/tokens'

const tokens = {
  backgroundColor: oliveBadgeTokens.badgeStatusBgColorAlert,
  borderColor: oliveBadgeTokens.badgeAlertBorderColorDefault,
} as const

export default tokens
